import { render } from "./step1.vue?vue&type=template&id=6d821588&scoped=true"
import script from "./step1.vue?vue&type=script&lang=ts"
export * from "./step1.vue?vue&type=script&lang=ts"

import "./step1.vue?vue&type=style&index=0&id=6d821588&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6d821588"

export default script